import { render, staticRenderFns } from "./InsurancesPlansTable.vue?vue&type=template&id=aba255d8&"
import script from "./InsurancesPlansTable.vue?vue&type=script&lang=js&"
export * from "./InsurancesPlansTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports